<template>
    <div class="footer">
      Версия клиента: {{ client }}, версия сервера: {{ server || 'н/д'}}
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'Footer',
      data() {
        return {
            client: this.$store.getters.getClientVersion,
            server: this.$store.getters.getServerVersion,
        }
      },
      async mounted() {
        if (!this.server){
          const result = await this.$store.dispatch('loadServerVersion');
          if (result.error == 0)
            this.server = result.data;
        }
        
      },
    };
  </script>
  <style scoped>
    .footer {
        background-color: #f0f0f070;
        position: fixed;
        right: 0;
        bottom: 0;
        text-align:right;
        width: 100%;
        padding: 5px 2em;
        font-size: 9px;
        color: gray;  
      }
  </style>